webpackJsonp([137176116301229],{

/***/ 436:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>I have just released a dev branch of my first ReactJS application which utilises Firebase database. If you are looking to build a ReactJS application, then I encourage you to clone my repo and create any PRs which you think will be helpful towards the project. You can also preview my ReactJS blogging app here and please let me know what you think of it.</p>\n<ul>\n<li><a href=\"https://github.com/Michael-Brooks/react-blog\">ReactJS Github repo</a></li>\n<li><a href=\"https://blog-51acb.firebaseapp.com/\">Preview Blogging Application</a></li>\n</ul>\n<p>You can contact me through comments on this blog post, or you can message me on GH with any questions/suggestions.</p>","frontmatter":{"categories":["General Updates","ReactJS","JavaScript"],"date":"January 08, 2017","featuredImage":"placeholder.png","title":"ReactJS Firebase Blogging Application"}}},"pathContext":{"slug":"/reactjs-firebase-blogging-application/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---post-reactjs-firebase-blogging-application-645d19953910ff700240.js